export const TEST_ID = 'serviceIntervalsModal';
